import { TypeAsserter } from '@attain-apps/type-guards'

import * as core from '../../core'

import type { Record } from './record'

/**
 * A link between a Lab and a Lab Service that serves it, along with what
 * describes both of their Space Records
 */
export interface LabAssignment {
  id: LabAssignment.Id
  lab: LabAssignment.Room
  labService: LabAssignment.Room
}

export namespace LabAssignment {
  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  /**
   * A Space Record a {@link LabAssignment} links
   *
   * NOTE: `globalThis.Record` because `Record` refers to the space record
   * entity in this file
   */
  export type Room = core.common.Identified<Record.Id> &
    core.common.Named & {
      /** The Space Record's ancestors (e.g. its building and floor) */
      ancestors: globalThis.Record<core.dms.models.Entity.Id, core.common.Named>
      roomType?: core.common.Coded & {
        /** The Room Type's HEGIS code, when it has one */
        hegisCode?: string
      }
    }
}
